import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OCRItemContainerModel } from "../../../../../models";
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

// https://api.akaun.dev/core2/platform/dm/tenants/tenant-users

@Injectable({
  providedIn: 'root'
})

export class OCRItemService extends BaseApiTemplateService<OCRItemContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/items/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/items/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ocr/items/backoffice-ep';
    this.httpClient = http;
  }
}

